export class _AbcTreeNode<T = unknown> {
  id: string;
  parentId?: string;
  caption: string;
  icon?: string;
  visible?: boolean;
  children: _AbcTreeNode<T>[] = [];
  expanded?: boolean;
  data?: T;
  parentNode?: _AbcTreeNode;
}
